module.exports = __webpack_public_path__ + "img/inventory-warning.163e3542.svg";